module.exports = __webpack_public_path__ + "static/media/JPBA08.31fca041.jpg";